<arm-side-nav [items]="callFlowItems" [title]="'Call Flow Configurations'" class="settings"></arm-side-nav>
